import { WebAudioArtifactRef, WebAudioArtifactSnapshot } from "./web-audio-artifact-types";

type WebAudioArtifactLike = Pick<WebAudioArtifactRef, "durationMs" | "sizeBytes">;

export const isWebAudioArtifactMissingOrEmpty = ({
  artifactRef,
}: {
  artifactRef: WebAudioArtifactRef | null;
}): boolean => {
  return artifactRef === null || artifactRef.sizeBytes <= 0;
};

export const getWebAudioArtifactDurationMs = ({
  artifact,
}: {
  artifact: WebAudioArtifactLike | WebAudioArtifactSnapshot | null;
}): number | null => {
  if (!artifact) {
    return null;
  }

  if (typeof artifact.durationMs !== "number" || !Number.isFinite(artifact.durationMs)) {
    return null;
  }

  return Math.max(0, Math.round(artifact.durationMs));
};
